export enum Experiment {
  EnableCSSOptimization = 'specs.myAccount.EnableCSSOptimization',
  EnablePhoneNumberValidation = 'specs.myAccount.EnablePhoneNumberValidation',
  EnableDatePickerStyling = 'specs.myAccount.EnableDatePickerStyling',
  EnableLoginAndAddressInTextsTab = 'specs.myAccount.EnableLoginAndAddressInTextsTab',
  EnableAllSubdivisionsInAddressForm = 'specs.myAccount.EnableAllSubdivisionsInAddressForm',
  EnableHtmlTagSettings = 'specs.myAccount.EnableHtmlTagSettings',
}
